// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-funnelFooter-reference {
  height: 70px;
  width: 100%;
  margin-bottom: -80px;
}

.srprs-funnelFooter {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  position: fixed;
  width: 100%;
  height: 70px;
  bottom: 0;
  left: 0;
  z-index: 996;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  background-color: #fff;
}
.srprs-funnelFooter.is-mobile-position-bottom {
  position: relative;
  overflow-x: hidden;
}
.srprs-funnelFooter.sticky-stop {
  position: relative;
  overflow-x: hidden;
}
.srprs-funnelFooter .submit-mobile {
  align-self: flex-end;
  height: 100%;
}
.srprs-funnelFooter .submit-mobile .srprs-button.type-primary {
  height: 100%;
  width: 100%;
  line-height: 100%;
  font-size: 15px;
  font-weight: bold;
  border-radius: 0;
  padding-left: 20px;
  padding-right: 20px;
}
.srprs-funnelFooter .submit-mobile .srprs-button.type-primary .srprs-icon {
  width: 15px;
  height: 15px;
}
.srprs-funnelFooter > div.submit-mobile {
  display: flex;
  align-items: center;
}
.srprs-funnelFooter > .wrapper-inner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  width: 100%;
  padding-left: 20px;
}
.srprs-funnelFooter > .wrapper-inner > div.funnel-footer-buttons-group,
.srprs-funnelFooter > .wrapper-inner > div.submit-desktop {
  display: none;
}
.srprs-funnelFooter > .wrapper-inner > div.total-price-box,
.srprs-funnelFooter > .wrapper-inner > div.more-details-box {
  display: block;
}
.srprs-funnelFooter > .wrapper-inner > div.total-price-box .total-label {
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  color: #8a8a8a;
  margin: 0;
}
.srprs-funnelFooter > .wrapper-inner > div.total-price-box .total {
  font-size: 18px;
  line-height: 24px;
}
.srprs-funnelFooter > .wrapper-inner > div.more-details-box {
  display: flex;
  justify-content: center;
  flex-grow: 1;
}
.srprs-funnelFooter > .wrapper-inner > div.more-details-box .srprs-button.type-inverted {
  height: 40px;
  font-weight: normal;
  font-size: 14px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  text-transform: unset;
  padding: 0 10px;
  text-align: center;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box {
  display: none;
  position: relative;
  margin-right: 12px;
  min-width: 80px;
  text-align: left;
  line-height: 22px;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row {
  display: flex;
  align-items: center;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row .show-details {
  width: 100%;
  display: block;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border-width: 0;
  font-size: 16px;
  line-height: 16px;
  text-align: inherit;
  cursor: pointer;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row .show-details .srprs-icon {
  bottom: auto;
  margin-left: 6px;
  font-size: 12px;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row .show-details:hover {
  text-decoration: underline;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row .show-details:focus {
  outline: 0;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .details-row .strike-through {
  margin-left: auto;
  padding: 0 10px;
  text-decoration: line-through;
  font-size: 16px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .total-row {
  display: flex;
  align-items: center;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: 800;
  font-size: 24px;
  text-transform: uppercase;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .total-row .total-label {
  margin-right: 10px;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .total-row .pill {
  display: block;
  margin-left: auto;
  padding: 5px 10px;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .total-row .pill.show {
  background-color: var(--colorBackground);
  border-radius: 20px;
}
.srprs-funnelFooter > .wrapper-inner > div.details-price-box .total {
  display: block;
  color: #222;
  font-size: 16px;
  font-weight: 800;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  text-transform: uppercase;
}
.srprs-funnelFooter > .wrapper-inner > div.giftcard-box {
  display: none;
}
.srprs-funnelFooter .details-price-box {
  width: 32%;
}
.srprs-funnelFooter .funnel-footer-buttons-group {
  display: flex;
  justify-content: space-around;
  width: 66%;
  align-items: center;
  flex-wrap: nowrap;
}
.srprs-funnelFooter .funnel-footer-buttons-group.extras .giftcard-box {
  width: 37%;
}
.srprs-funnelFooter .funnel-footer-buttons-group.extras .giftcard-box .srprs-button {
  width: 100%;
}
.srprs-funnelFooter .funnel-footer-buttons-group.extras .submit-desktop {
  width: 62%;
}
.srprs-funnelFooter .funnel-footer-buttons-group.extras .submit-desktop .srprs-button {
  width: 100%;
}
.srprs-funnelFooter .funnel-footer-buttons-group .giftcard-box,
.srprs-funnelFooter .funnel-footer-buttons-group .submit-desktop {
  width: 44%;
}
.srprs-funnelFooter .funnel-footer-buttons-group .giftcard-box .srprs-button,
.srprs-funnelFooter .funnel-footer-buttons-group .submit-desktop .srprs-button {
  width: 100%;
}

@media screen and (min-width: 375px) {
  .srprs-funnelFooter > .wrapper-inner > div.details-price-box {
    line-height: 22px;
  }
  .srprs-funnelFooter > .wrapper-inner > div.details-price-box > span {
    font-size: 18px;
  }
}
@media screen and (min-width: 768px) {
  .srprs-funnelFooter-reference {
    height: 106px;
    width: 100%;
    margin-bottom: -106px;
  }
  .srprs-funnelFooter {
    height: 106px;
    background-color: #f4f4f4;
    box-shadow: 0 0 10px 10px rgba(34, 34, 34, 0.1);
  }
  .srprs-funnelFooter > .wrapper-inner {
    position: relative;
    margin: 0 auto;
    width: calc(100% - 40px);
    max-width: 706px;
  }
  .srprs-funnelFooter.is-mobile-position-bottom {
    position: fixed;
  }
  .srprs-funnelFooter > div.submit-mobile {
    display: none;
  }
  .srprs-funnelFooter > .wrapper-inner {
    padding-left: 0;
  }
  .srprs-funnelFooter > .wrapper-inner > div.funnel-footer-buttons-group {
    display: flex;
  }
  .srprs-funnelFooter > .wrapper-inner > div.submit-desktop {
    display: block;
  }
  .srprs-funnelFooter > .wrapper-inner > div.total-price-box,
  .srprs-funnelFooter > .wrapper-inner > div.more-details-box {
    display: none;
  }
  .srprs-funnelFooter > .wrapper-inner > div.details-price-box {
    display: block;
    white-space: nowrap;
    min-width: none;
    line-height: 22px;
  }
  .srprs-funnelFooter > .wrapper-inner > div.details-price-box:after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 1px;
    height: 130%;
    top: -5px;
    right: -1%;
    background-color: #cecece;
  }
  .srprs-funnelFooter > .wrapper-inner > div.giftcard-box {
    display: block;
    width: 220px;
  }
  .srprs-funnelFooter > .wrapper-inner > div.submit-desktop .srprs-button {
    padding-left: 1.75em;
    padding-right: 1.75em;
  }
  .srprs-funnelFooter > .wrapper-inner > div.submit-desktop .srprs-button span:nth-child(1) {
    max-width: none;
  }
  .srprs-funnelFooter > .wrapper-inner > div.submit-desktop .srprs-button span:nth-child(1):not(.to-payment):after {
    content: ":";
    margin-right: 4px;
  }
  .srprs-funnelFooter > .wrapper-inner > div.submit-desktop .srprs-button span.hide-step {
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-funnelFooter > .wrapper-inner > div.giftcard-box {
    display: block;
    width: 190px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/FunnelFooter/FunnelFooter.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_wrapper-inner.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AAtMA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;AAwMF;;AArMA;EIKI,6CAAA;EJFF,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EAGE,sBAAA;AAoMJ;AAjME;EACE,kBAAA;EACA,kBAAA;AAmMJ;AAjME;EACE,kBAAA;EACA,kBAAA;AAmMJ;AAhME;EACE,oBAAA;EACA,YAAA;AAkMJ;AAjMI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAmMN;AAjMM;EACE,WAAA;EACA,YAAA;AAmMR;AA9LE;EACE,aAAA;EACA,mBAAA;AAgMJ;AA9LE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EAGE,kBAAA;AA8LN;AA3LI;;EAEE,aAAA;AA6LN;AA3LI;;EAEE,cAAA;AA6LN;AA1LM;EAEI,eAAA;EACA,gBAAA;EAEF,iBAAA;EACA,cAAA;EACA,SAAA;AA0LR;AAxLM;EACE,eAAA;EACA,iBAAA;AA0LR;AAvLI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAyLN;AAvLM;EACE,YAAA;EAEE,mBAAA;EACA,eAAA;EACA,2IAAA;EAEF,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAuLR;AApLI;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAsLN;AArLM;EACE,aAAA;EACA,mBAAA;AAuLR;AAtLQ;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAwLV;AAtLU;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AAwLZ;AArLU;EACE,0BAAA;AAuLZ;AArLU;EACE,UAAA;AAuLZ;AApLQ;EACE,iBAAA;EACA,eAAA;EACA,6BAAA;EAEE,eAAA;EACA,2IAAA;AAqLZ;AAjLM;EACE,aAAA;EACA,mBAAA;EAEE,2IAAA;EACA,gBAAA;EACA,eAAA;EAEF,yBAAA;AAiLR;AAhLQ;EACE,kBAAA;AAkLV;AAhLQ;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AAkLV;AAjLU;EACE,wCAAA;EACA,mBAAA;AAmLZ;AA9KM;EACE,cAAA;EACA,WAAA;EAEE,eAAA;EACA,gBAAA;EACA,2IAAA;EAEF,yBAAA;AA8KR;AA1KI;EAEE,aAAA;AA2KN;AAvKE;EACE,UAAA;AAyKJ;AAvKE;EACE,aAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;AAyKJ;AAvKM;EACE,UAAA;AAyKR;AAxKQ;EACE,WAAA;AA0KV;AAvKM;EACE,UAAA;AAyKR;AAxKQ;EACE,WAAA;AA0KV;AAtKI;;EAEE,UAAA;AAwKN;AAvKM;;EACE,WAAA;AA0KR;;AC5YI;ED2OE;IACE,iBAAA;EAqKN;EApKM;IAEI,eAAA;EAqKV;AACF;ACrZI;EDwPF;IACE,aAAA;IACA,WAAA;IACA,qBAAA;EAgKF;EA7JA;IAEE,aAAA;IAEE,yBAAA;IAGA,+CAAA;EA2JJ;EKnaA;IACE,kBAAA;IACA,cAAA;IACA,wBAAA;IAEE,gBAAA;ELoaJ;EA9JE;IACE,eAAA;EAgKJ;EA9JE;IACE,aAAA;EAgKJ;EA9JE;IACE,eAAA;EAgKJ;EA/JI;IACE,aAAA;EAiKN;EA/JI;IACE,cAAA;EAiKN;EA/JI;;IAEE,aAAA;EAiKN;EA/JI;IACE,cAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;EAiKN;EAhKM;IACE,WAAA;IACA,kBAAA;IACA,qBAAA;IACA,UAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IAEE,yBAAA;EAiKV;EA7JI;IAEE,cAAA;IACA,YAAA;EA8JN;EA1JM;IAEI,oBAAA;IACA,qBAAA;EA2JV;EAxJU;IACE,eAAA;EA0JZ;EAxJc;IACE,YAAA;IACA,iBAAA;EA0JhB;EAtJU;IACE,aAAA;EAwJZ;AACF;AC5dI;ED+UE;IAEE,cAAA;IACA,YAAA;EA+IN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n@import '../_Assets/scss/core';\n\n.srprs-funnelFooter-reference {\n  height: 70px;\n  width: 100%;\n  margin-bottom: -80px;\n}\n\n.srprs-funnelFooter {\n  @include box-shadow();\n\n  position: fixed;\n  width: 100%;\n  height: 70px;\n  bottom: 0;\n  left: 0;\n  z-index: z-index(notification);\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  align-content: stretch;\n\n  background: {\n    color: color(white);\n  }\n\n  &.is-mobile-position-bottom {\n    position: relative;\n    overflow-x: hidden;\n  }\n  &.sticky-stop {\n    position: relative;\n    overflow-x: hidden;\n  }\n\n  .submit-mobile {\n    align-self: flex-end;\n    height: 100%;\n    .srprs-button.type-primary {\n      height: 100%;\n      width: 100%;\n      line-height: 100%;\n      font-size: 15px;\n      font-weight: bold;\n      border-radius: 0;\n      padding-left: 20px;\n      padding-right: 20px;\n\n      .srprs-icon {\n        width: 15px;\n        height: 15px;\n      }\n    }\n  }\n\n  > div.submit-mobile {\n    display: flex;\n    align-items: center;\n  }\n  > .wrapper-inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    align-content: stretch;\n    width: 100%;\n\n    padding: {\n      left: 20px;\n    }\n\n    > div.funnel-footer-buttons-group,\n    > div.submit-desktop {\n      display: none;\n    }\n    > div.total-price-box,\n    > div.more-details-box {\n      display: block;\n    }\n    > div.total-price-box {\n      .total-label {\n        font: {\n          size: 16px;\n          weight: 400;\n        }\n        line-height: 16px;\n        color: #8a8a8a;\n        margin: 0;\n      }\n      .total {\n        font-size: 18px;\n        line-height: 24px;\n      }\n    }\n    > div.more-details-box {\n      display: flex;\n      justify-content: center;\n      flex-grow: 1;\n\n      .srprs-button.type-inverted {\n        height: 40px;\n        font: {\n          weight: normal;\n          size: 14px;\n          family: font(body);\n        }\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 14px;\n        text-transform: unset;\n        padding: 0 10px;\n        text-align: center;\n      }\n    }\n    > div.details-price-box {\n      display: none;\n      position: relative;\n      margin-right: 12px;\n      min-width: 80px;\n      text-align: left;\n      line-height: 22px;\n      .details-row {\n        display: flex;\n        align-items: center;\n        .show-details {\n          width: 100%;\n          display: block;\n          margin: 0;\n          padding: 0;\n          background-color: transparent;\n          border-width: 0;\n          font-size: 16px;\n          line-height: 16px;\n          text-align: inherit;\n          cursor: pointer;\n\n          .srprs-icon {\n            bottom: auto;\n            margin-left: 6px;\n            font-size: 12px;\n          }\n\n          &:hover {\n            text-decoration: underline;\n          }\n          &:focus {\n            outline: 0;\n          }\n        }\n        .strike-through {\n          margin-left: auto;\n          padding: 0 10px;\n          text-decoration: line-through;\n          font: {\n            size: 16px;\n            family: font(heading);\n          }\n        }\n      }\n      .total-row {\n        display: flex;\n        align-items: center;\n        font: {\n          family: font(heading);\n          weight: 800;\n          size: 24px;\n        }\n        text-transform: uppercase;\n        .total-label {\n          margin-right: 10px;\n        }\n        .pill {\n          display: block;\n          margin-left: auto;\n          padding: 5px 10px;\n          &.show {\n            background-color: var(--colorBackground);\n            border-radius: 20px;\n          }\n        }\n      }\n\n      .total {\n        display: block;\n        color: color(black);\n        font: {\n          size: 16px;\n          weight: 800;\n          family: font(heading);\n        }\n        text-transform: uppercase;\n      }\n    }\n\n    > div.giftcard-box {\n      // giftcard\n      display: none;\n    }\n  }\n\n  .details-price-box {\n    width: 32%;\n  }\n  .funnel-footer-buttons-group {\n    display: flex;\n    justify-content: space-around;\n    width: 66%;\n    align-items: center;\n    flex-wrap: nowrap;\n    &.extras {\n      .giftcard-box {\n        width: 37%;\n        .srprs-button {\n          width: 100%;\n        }\n      }\n      .submit-desktop {\n        width: 62%;\n        .srprs-button {\n          width: 100%;\n        }\n      }\n    }\n    .giftcard-box,\n    .submit-desktop {\n      width: 44%;\n      .srprs-button {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-funnelFooter {\n    > .wrapper-inner {\n      > div.details-price-box {\n        line-height: 22px;\n        > span {\n          font: {\n            size: 18px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-funnelFooter-reference {\n    height: 106px;\n    width: 100%;\n    margin-bottom: -106px;\n  }\n\n  .srprs-funnelFooter {\n    @include wrapper-inner(section(max-width-xs));\n    height: 106px;\n    background: {\n      color: lighten(color(grey-light), 5%);\n    }\n    box: {\n      shadow: 0 0 10px 10px rgba(color(black), 0.1);\n    }\n\n    &.is-mobile-position-bottom {\n      position: fixed;\n    }\n    > div.submit-mobile {\n      display: none;\n    }\n    > .wrapper-inner {\n      padding-left: 0;\n      > div.funnel-footer-buttons-group {\n        display: flex;\n      }\n      > div.submit-desktop {\n        display: block;\n      }\n      > div.total-price-box,\n      > div.more-details-box {\n        display: none;\n      }\n      > div.details-price-box {\n        display: block; // for not-mobile\n        white-space: nowrap;\n        min-width: none;\n        line-height: 22px;\n        &:after {\n          content: '';\n          position: absolute;\n          display: inline-block;\n          width: 1px;\n          height: 130%;\n          top: -5px;\n          right: -1%;\n          background: {\n            color: darken(color(grey-light), 10%);\n          }\n        }\n      }\n      > div.giftcard-box {\n        //giftcard\n        display: block;\n        width: 220px;\n      }\n      > div.submit-desktop {\n        //submit\n        .srprs-button {\n          padding: {\n            left: 1.75em;\n            right: 1.75em;\n          }\n          span {\n            &:nth-child(1) {\n              max-width: none;\n              &:not(.to-payment) {\n                &:after {\n                  content: ':';\n                  margin-right: 4px;\n                }\n              }\n            }\n            &.hide-step {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-funnelFooter {\n    > .wrapper-inner {\n      > div.giftcard-box {\n        //giftcard\n        display: block;\n        width: 190px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin wrapper-inner($max-width: '') {\n  > .wrapper-inner {\n    position: relative;\n    margin: 0 auto;\n    width: calc(100% - 40px);\n    @if $max-width != '' {\n      max-width: ($max-width);\n    } @else {\n      max-width: 1140px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
